module.exports = __webpack_public_path__ + "img/vision_1.f47657ac.png";